module.exports = __webpack_public_path__ + "static/canada-d1b5547175698a5691c8726e5224a643.png";